<template>
<v-container fluid  class="weaver-faqs">
    <v-container class="faqs-container" style="padding:0px;" >
        <v-layout column style="margin-left:10px;margin-right:10px" >
               <v-layout row style="background:#86af49; border-radius:25px 25px 0px 0px">
         <v-flex grow="1" class="subheading mt-3" style="color:#DDDDDD;padding-left:20px;padding-bottom:5px">10:46 AM</v-flex>      
              <v-layout shrink="1" align-start justify-end row>
                  <v-img position="center center" width="20px" height="20px" src="~@/assets/images/wifi.png" contain="true" style="margin-top:12px;margin-right:5px" />
                  <div class="subheading mt-3" style="text-align: right;color:#DDDDDD;padding-right:2px">54%</div>
                   <v-img position="center center" width="15px" height="20px" src="~@/assets/images/battery.png" contain="true" style="margin-top:12px;margin-right:30px" />    
              </v-layout>               
        </v-layout>
        <v-layout row  style="background:#EEEEEE;height:60px">
        <v-flex>
            <v-img position="center left" width="40px" height="40px" src="~@/assets/images/weaversmall.png" contain="true" style="margin-top:10px;margin-left:20px;float:left" />
             <v-flex class="headline mt-3" style="padding-left:70px;padding-top:10px">faqs</v-flex>
        </v-flex>
        <v-img position="center right" width="20px" height="20px" src="~@/assets/images/hamburger.png" contain="true" style="margin-top:20px;margin-right:20px;" />
        </v-layout>
        <v-layout row style="background:#999999;height:2px">
        </v-layout>
        <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Hey FutureOstrich, you around?</v-flex>
         </v-layout>

          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
             <v-img position="center left" width="40px" height="40px" src="~@/assets/images/rank.png" contain="true" style="margin-top:0px;margin-left:20px;float:left" />
              <v-flex class="subheading mt-3" style="padding-left:30px;padding-top:0px;font-weight:bold">FutureOstrich</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Indeed I am, what did you need help with?</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Let's see...</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Ok, what are Rank Points and how can I get them?</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
             <v-img position="center left" width="40px" height="40px" src="~@/assets/images/rank.png" contain="true" style="margin-top:0px;margin-left:20px;float:left" />
              <v-flex class="subheading mt-3" style="padding-left:30px;padding-top:0px;font-weight:bold">FutureOstrich</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Rank Points are used to increase your Rank, higher Ranks means more Perks</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">To earn Rank Points you first must be a registered user</v-flex>
         </v-layout>
        <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">From there you will earn Rank Points just by using Weaver, sending messages, receiving Kudos</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">You can also boost your Rank Points in the store if you want to quickly gain Ranks</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">You mentioned Kudos. How do I send Kudos?</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
             <v-img position="center left" width="40px" height="40px" src="~@/assets/images/rank.png" contain="true" style="margin-top:0px;margin-left:20px;float:left" />
              <v-flex class="subheading mt-3" style="padding-left:30px;padding-top:0px;font-weight:bold">FutureOstrich</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">There's a bunch of stuff you can do if you select a message within a channel</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">You can quote, copy, report, send Kudos and even take back the Kudos in the event of accidental Kudos-ing</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">That menu also allows you to Inbox the user that sent that message or invite them to a Private Channel</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Ok got it. How about Private Channels? If I create one, how can people join it?</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
             <v-img position="center left" width="40px" height="40px" src="~@/assets/images/rank.png" contain="true" style="margin-top:0px;margin-left:20px;float:left" />
              <v-flex class="subheading mt-3" style="padding-left:30px;padding-top:0px;font-weight:bold">FutureOstrich</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">When you create a Private Channel there are two ways of inviting people</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">First, every Private Channel has a name, number and password. The channel number is everything after the # symbol</v-flex>
         </v-layout>
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Anyone who has those three pieces of information can join your private channel. Although if someone you didn't like joined you can still ban them from the channel</v-flex>
         </v-layout>
                  <v-layout row wrap style="background:#EEEEEE;padding-top:0px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Alternatively, as mentioned before you can select a users message from any channel and invite that user via Inboxing</v-flex>
         </v-layout>
          <v-layout row wrap style="background:#EEEEEE;height:40px;padding-top:10px">
             <v-flex>
              <v-flex class="subheading mt-3" style="padding-left:20px;padding-top:0px;font-weight:bold">MountainCobbler</v-flex>
             </v-flex>
        </v-layout>   
         <v-layout row wrap style="background:#EEEEEE;padding-top:0px;padding-bottom:20px">
               <v-flex class="subheading mt-3" style="padding-left:20px;padding-right:20px;padding-top:0px;">Thanks for all your help. If I think of anything else I'll add it here</v-flex>
         </v-layout>
        <v-layout row style="background:#999999;height:2px;padding:0px">
        </v-layout>
         <v-layout row wrap style="background:#EEEEEE;height:60px; border-radius:0px 0px 25px 25px">
        <v-flex class="headline mt-3" style="padding-left:20px;padding-top:2px">Message...</v-flex>
        <v-flex>
   <v-flex class="headline" style="text-align:center;height:60px;width:150px;color:#DDDDDD;background:#86af49;float:right;padding-top:12px;border-radius:0px 0px 25px 0px">Send</v-flex>
        </v-flex>
     
         </v-layout>
        </v-layout>
    </v-container>
       </v-container>
</template>

<script>
export default {
    name: 'WeaverFaqs'
};
</script>

<style scoped>
.weaver-faqs {
    background: #222222;
    width: 100%;
    padding-top: 100px;
}
.faqs-container {
    background: #EEEEEE;
    border-radius:25px;
  
}

</style>